export default __webpack_public_path__ + "static/best-practices-9f84246cc7665ef5008f821362ee0cc9.png";